import type { DrawObject } from "../types/document.ts";

const FRAME_PADDING = 20;

const MONTHS = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

function formatDate(iso?: string): string {
  const d = iso ? new Date(iso) : new Date();
  const year = d.getFullYear();
  const month = MONTHS[d.getMonth()];
  const day = String(d.getDate()).padStart(2, " ");
  const hour12 = d.getHours() % 12 || 12;
  const ampm = d.getHours() < 12 ? "AM" : "PM";
  const min = String(d.getMinutes()).padStart(2, "0");
  return `${year}  ${month}  ${day}    ${ampm}  ${hour12}  ${min}`;
}

function drawTelegramFrame(
  ctx: CanvasRenderingContext2D,
  w: number,
  h: number,
  sentAt?: string,
): void {
  ctx.fillStyle = "#F0E2C0";
  ctx.fillRect(0, 0, w, h);

  ctx.strokeStyle = "#8b7355";
  ctx.lineWidth = 1.5;
  ctx.strokeRect(FRAME_PADDING, FRAME_PADDING, w - FRAME_PADDING * 2, h - FRAME_PADDING * 2);

  ctx.font = "bold 11px 'Courier New', Courier, monospace";
  ctx.fillStyle = "#5D4037";
  ctx.textAlign = "right";
  ctx.fillText(formatDate(sentAt), w - 36, 38 + 11);
  ctx.textAlign = "left";
}

function drawObject(ctx: CanvasRenderingContext2D, obj: DrawObject): void {
  switch (obj.type) {
    case "pencil": {
      if (obj.points.length < 2) return;
      ctx.beginPath();
      ctx.moveTo(obj.points[0][0], obj.points[0][1]);
      for (let i = 1; i < obj.points.length; i++) {
        ctx.lineTo(obj.points[i][0], obj.points[i][1]);
      }
      ctx.strokeStyle = obj.color;
      ctx.lineWidth = obj.width;
      ctx.lineCap = "round";
      ctx.lineJoin = "round";
      ctx.stroke();
      break;
    }
    case "line": {
      ctx.beginPath();
      ctx.moveTo(obj.from[0], obj.from[1]);
      ctx.lineTo(obj.to[0], obj.to[1]);
      ctx.strokeStyle = obj.color;
      ctx.lineWidth = obj.width;
      ctx.lineCap = "round";
      ctx.stroke();
      break;
    }
    case "rect": {
      if (obj.fill) {
        ctx.fillStyle = obj.fill;
        ctx.fillRect(obj.origin[0], obj.origin[1], obj.size[0], obj.size[1]);
      }
      ctx.strokeStyle = obj.color;
      ctx.lineWidth = obj.width;
      ctx.strokeRect(obj.origin[0], obj.origin[1], obj.size[0], obj.size[1]);
      break;
    }
    case "ellipse": {
      if (obj.radii[0] <= 0 || obj.radii[1] <= 0) return;
      ctx.beginPath();
      ctx.ellipse(obj.center[0], obj.center[1], obj.radii[0], obj.radii[1], 0, 0, Math.PI * 2);
      if (obj.fill) {
        ctx.fillStyle = obj.fill;
        ctx.fill();
      }
      ctx.strokeStyle = obj.color;
      ctx.lineWidth = obj.width;
      ctx.stroke();
      break;
    }
    case "emoji": {
      ctx.font = `${obj.size}px serif`;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(obj.emoji, obj.position[0], obj.position[1]);
      break;
    }
  }
}

export function render(
  ctx: CanvasRenderingContext2D,
  objects: DrawObject[],
  inProgress: DrawObject | null,
  canvasWidth: number,
  canvasHeight: number,
  sentAt?: string,
): void {
  ctx.clearRect(0, 0, canvasWidth, canvasHeight);
  drawTelegramFrame(ctx, canvasWidth, canvasHeight, sentAt);
  for (const obj of objects) drawObject(ctx, obj);
  if (inProgress) drawObject(ctx, inProgress);
}
